import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isPriceBreaksPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup } from '../../../../common/redux/popup-manager/popup-manager.actions';
import { isLimitedEditionSelector } from '../../../redux/product/product.selectors';
import { PriceBreaksPopupComponent } from './price-breaks-popup';
const mapStateToProps = createStructuredSelector({
  open: isPriceBreaksPopupShownSelector,
  isLimitedEdition: isLimitedEditionSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(hidePopup())
});
export const PriceBreaksPopup = connect(mapStateToProps, mapDispatchToProps)(PriceBreaksPopupComponent);